export const xSmallCell = {
    size: 80,
    minSize: 80
};

export const smallCell = {
    size: 100,
    minSize: 100
};

export const mediumCell = {
    size: 120,
    minSize: 120
};

export const largeCell = {
    size: 150,
    minSize: 150
};

export const xLargeCell = {
    size: 180,
    minSize: 180
};

export const x2LargeCell = {
    size: 200,
    minSize: 200
};
